import { API_URL } from "../config/api";

export const getProjectDailyUpdates = async (token: string, project_id: string): Promise<ProjectDailyUpdatesInterface> => {
  try {
    const r = await fetch(`${API_URL}/projects/${project_id}/daily-update?size=1000`, {
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      }
    })
    const data:ProjectDailyUpdatesInterface = await r.json();

    return data;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};

export const getProjectDailyUpdatesById = async (token: string, project_id: string, record_id: string): Promise<ProjectDailyUpdate> => {
  try {
    const r = await fetch(`${API_URL}/projects/${project_id}/daily-update/${record_id}`, {
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      }
    })
    const data:any = await r.json();

    return data;
  } catch(e: Error | any) {
    throw new Error(e);
  }
}

export const createProjectDailyUpdates = async (token: string, project_id: string, data: ProjectDailyUpdate): Promise<ProjectDailyUpdate> => {
  try {
    const r = await fetch(`${API_URL}/projects/${project_id}/daily-update`,{
      method: 'POST',
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      },
      body: JSON.stringify(data)
    })
    if (!r.ok) {
      throw new Error(r.statusText);
    }

    const res:any = await r.json();

    return res;
  } catch(e: Error | any) {
    throw new Error(e);
  }
}

export const updateProjectDailyUpdates = async (token: string, project_id: string, record_id: string, data: ProjectDailyUpdate): Promise<any> => {
  try {
    const res = await fetch(`${API_URL}/projects/${project_id}/daily-update/${record_id}`,{
      method: 'PUT',
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      throw new Error(res.statusText);
    }
    

    return res;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};

export const deleteProjectDailyUpdates = async (token: string, project_id: string, record_id: string): Promise<ProjectDailyUpdate> => {
  try {
    const r = await fetch(`${API_URL}/projects/${project_id}/daily-update/${record_id}`,{
      method: 'DELETE',
      headers: {
        'content-type':'application/json',
        'authorization': 'Bearer ' + token
      }
    })
    const res:any = await r.json();

    return res;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};
